import React from 'react';
import { opsteamuser } from './Datatype';

interface props {
  showmodal: string;
  setshowmodal: (modal: string) => void;
  formdata: opsteamuser;
  setformdata: (data: opsteamuser) => void;
  handlesubmit: () => void;
}

const MasterOpsTeamForm: React.FC<props> = ({ 
  showmodal, 
  setshowmodal, 
  formdata, 
  setformdata, 
  handlesubmit 
}) => {
  if (showmodal !== "showopsteamform") return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h3>{formdata._id ? "Edit Ops Admin" : "Add Ops Admin"}</h3>
          <button className="close-btn" onClick={() => setshowmodal("")}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>Email Address</label>
            <input 
              type="email" 
              className="form-input" 
              placeholder="admin@reveen.com"
              value={formdata.email || ''} 
              onChange={(e) => setformdata({ ...formdata, email: e.target.value })} 
            />
          </div>

          <div className="form-group">
            <label>{formdata._id ? "New Password (leave blank to keep current)" : "Password"}</label>
            <input 
              type="password" 
              className="form-input" 
              placeholder="••••••••"
              value={formdata.password || ''} 
              onChange={(e) => setformdata({ ...formdata, password: e.target.value })} 
            />
          </div>

          <button className="btn-blue full-width" onClick={handlesubmit}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default MasterOpsTeamForm;